module.exports = __webpack_public_path__ + "img/Buybox Monitor_old.ca119524.svg";